
import { defineComponent } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';


export default defineComponent({
    name: 'FormBoolean',
    components: {
        Field,
        ErrorMessage
    },
    props: {
        name: { type: String, required: true },
        langKey: { type: String, required: true },
        rules: null,
        cssClass: { type: String, default: '' },
        hasTooltip: { type:Boolean, default: false },
        required: Boolean,
        disabled: Boolean,
        modelValue: { type: Boolean, default: undefined }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            input: this.modelValue
        }
    },
    watch: {
        modelValue(newVal) {
            this.input = newVal;
        },
        input(newVal) {
            this.$emit('update:modelValue', newVal);
        }
    },
    mounted() {
        if(this.hasTooltip) {
            const w: any = window;
            w.$(`#tooltip${this.name}`).tooltipster({
                theme: 'tooltipster-WDI',
                delay: 100,
                animation: 'grow',
                trigger: 'click',
                maxWidth: '250'
            });
        }
    }
})
